import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

import { type Panel, PANEL_VALUES } from "./schemas"

/**
 * Aktif panel state'i. Auth store'dan ayrık tutulur — lifecycle farklı:
 *  - login sonrası set edilir (tek panelliyse otomatik, çift panelliyse seçim sonrası)
 *  - logout / panel switch'te clear veya değişir
 *  - sessionStorage'da persist eder, tab kapanınca temizlenir
 */

const STORAGE_KEY = "ok.panel"

function readPersisted(): Panel | null {
  if (typeof window === "undefined") {
    return null
  }
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    return (PANEL_VALUES as readonly string[]).includes(raw) ? (raw as Panel) : null
  } catch {
    return null
  }
}

function persist(value: Panel | null) {
  if (typeof window === "undefined") {
    return
  }
  if (value) {
    window.sessionStorage.setItem(STORAGE_KEY, value)
  } else {
    window.sessionStorage.removeItem(STORAGE_KEY)
  }
}

interface PanelState {
  active: Panel | null
  setActive: (panel: Panel | null) => void
  clear: () => void
}

export const usePanelStore = create<PanelState>()(
  immer((set) => ({
    active: readPersisted(),
    setActive: (panel) =>
      set((state) => {
        state.active = panel
      }),
    clear: () =>
      set((state) => {
        state.active = null
      }),
  })),
)

usePanelStore.subscribe((state) => {
  persist(state.active)
})
